export default __webpack_public_path__ + "static/media/landing.ccc79d8e.png";